import { render, staticRenderFns } from "./LivingTravel.vue?vue&type=template&id=41f11f97&scoped=true&"
import script from "./LivingTravel.vue?vue&type=script&lang=js&"
export * from "./LivingTravel.vue?vue&type=script&lang=js&"
import style0 from "./LivingTravel.vue?vue&type=style&index=0&id=41f11f97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f11f97",
  null
  
)

export default component.exports